export enum FeatureFlag {
    CustomUOM = 'custom_uom',
    DepositAndCredit = 'deposit_and_credit',
    MenuLive = 'menu_live',
}
